module.exports = __webpack_public_path__ + "img/Banner-Construction.11d4a6fe.jpg";